import React from "react";
import moment from "moment";

import { Box, Typography } from "@mui/material";

import { Request, Trip } from "../../types";
import { alabaster } from "../../design-system/colors";
import { confirmationNumberFromRequest } from "../../globals/utils/helpers";
import { useOperatorCurrency, useTimeFormat } from "globals/hooks";

type TripListItemMobileProps = {
  trip: Trip;
  request: Request;
};

function TripListItemMobile(props: TripListItemMobileProps) {
  const { trip, request } = props;
  const currency = useOperatorCurrency();
  const { formatTime, formatDate } = useTimeFormat();

  const {
    stops,
    contact,
    totalAmount,
    amountDue,
    temporaryPassenger,
    totalPaid,
  } = trip;
  const firstStopDateTime = `${formatDate(moment.utc(stops[0].dateTime))} ${formatTime(moment.utc(stops[0].dateTime))}`;

  const tripContactName = temporaryPassenger?.name
    ? temporaryPassenger.name
    : `${contact.firstName} ${contact.lastName}`;

  return (
    <Box
      display="flex"
      bgcolor={alabaster}
      flexDirection="column"
      flex="1"
      p={2}
      alignItems="center"
    >
      {/* row 1 */}
      <Box display="flex" flexDirection="row" mb={1} width="100%">
        {/* date */}
        <Box display="flex" flexDirection="column" flex="1">
          <Typography variant="overline">date</Typography>
          <Typography variant="subtitle2">
            {confirmationNumberFromRequest(request, trip)}
          </Typography>
          <Typography variant="body2">{firstStopDateTime}</Typography>
          <Typography variant="body2">{tripContactName}</Typography>
          {trip.cancelledAt && (
            <Typography variant="body2">Cancelled</Typography>
          )}
        </Box>

        {/* pickup address */}
        <Box display="flex" flexDirection="column" flex="1">
          <Typography variant="overline">pick up address</Typography>
          <Typography variant="body2">{stops[0].location}</Typography>
        </Box>
      </Box>

      {/* row 2 */}
      <Box display="flex" flexDirection="row" alignSelf="stretch">
        {/* amount */}
        <Box display="flex" flexDirection="column" flex="1">
          <Typography variant="overline">amount</Typography>
          <Typography variant="body2">{currency(totalAmount)}</Typography>
        </Box>

        {/* paid */}
        <Box display="flex" flexDirection="column" flex="1">
          <Typography variant="overline">paid</Typography>
          <Typography variant="body2">{currency(totalPaid)}</Typography>
        </Box>

        {/* amountDue */}
        <Box display="flex" flexDirection="column" flex="2">
          <Typography variant="overline">amount due</Typography>
          <Typography variant="body2">{currency(amountDue)}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default TripListItemMobile;
